import Vue from 'vue';
import Component from 'vue-class-component';
import ChatIcon from './ChatIcon.vue';
import * as $ from 'jquery';

@Component({
  props: {
    open: Boolean,
  },
  components: {ChatIcon},
})
export default class ChatForm extends Vue {
  firstName: string = '';
  lastName: string = '';

  get author(): string {
    return this.firstName + ' ' + this.lastName;
  }

  mounted() {
    this.initializeChatForm();
  }

  get validationErrors() {
    return this.$validator.errors.count() > 0;
  }

  initializeChatForm() {
    import('fancybox/source/jquery.fancybox.pack.js').then(() => {
      $('.js-showChatBox').fancybox({
        padding: 0,
        margin: [0, 0, 20, 0],
        autoSize: true,
        maxWidth: 550,
        minWidth: 550,
        prevEffect: 'none',
        nextEffect: 'none',
        wrapCSS: 'js-fancyboxWrapper chatbox__container',
        helpers: {
          title: {
            type: 'outside', // 'float', 'inside', 'outside' or 'over'
          },
        },
        afterShow: () => {
          $('.js-chatBoxFancyBoxClose').on('click', (event) => {
            event.preventDefault();
            // @ts-ignore typescript doesn't recognize the fancybox-type on jQueryStatic-Interface
            $.fancybox.close();
          });
        },
      });
    });
  }
}
